import { render, staticRenderFns } from "./MdCheckListBox2.vue?vue&type=template&id=4470f5e2&"
import script from "./MdCheckListBox2.vue?vue&type=script&lang=js&"
export * from "./MdCheckListBox2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports